import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import {useState} from "react";
import Droppable from "./Droppable";

const SortableList = props => {
    const [items, setItems] = useState(props.items);
    const [itemsCollapsed, setItemsCollapsed] = useState(false);
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5
            }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );

    function handleDragStart() {
        setItemsCollapsed(true);
    }

    function handleDragEnd(event) {
        const {active, over} = event;

        setItemsCollapsed(false);

        if (active.id !== over.id){
            setItems((currItems) => {
                const oldIndex = currItems.findIndex(item => item.id === active.id);
                const newIndex = currItems.findIndex(item => item.id === over.id);
                const sortedItems = arrayMove(currItems, oldIndex, newIndex)

                props.onItemsSort(sortedItems)
                return sortedItems;
            })
        }
    }

    return <>
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            onDragStart={handleDragStart}
            >
            <Droppable items={items} collapsed={itemsCollapsed} />
        </DndContext>
    </>
}

export default SortableList;